import { ApplicationState } from 'application/redux';
import { goToFirstPage } from 'core/pagination-optimized/redux/actions';
import { connect } from 'react-redux';
import { deleteItem, onChangeAccordionPage, toggleItem } from './redux/actions';
import TableAccordionComponent from './table-accordion-component';

const mapStateToProps = (state: ApplicationState) => ({
  t: state.i18n.t,
  tableAccordion: state.accordion,
  pagination: state.pagination.pagination,
  table: state.table
});

export default connect(mapStateToProps, {
  toggleItem,
  deleteItem,
  onChangeAccordionPage,
  goToFirstPage
})(TableAccordionComponent);
